import { Eye } from "lucide-react";

// Compact "viewed N times · last by X" badge for office document rows.
export function ViewCountBadge({ stat }) {
  if (!stat || !stat.count) return null;
  const n = stat.count;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-slate-100 border border-slate-200 px-2 py-0.5 text-[9px] font-medium text-slate-500"
      title={`${n} view${n === 1 ? "" : "s"} by ${stat.workers} worker${stat.workers === 1 ? "" : "s"}`
        + (stat.acknowledged ? ` · ${stat.acknowledged} acknowledged` : "")}
      data-testid="doc-view-badge">
      <Eye className="h-3 w-3" />
      viewed {n}×{stat.last_by ? ` · last by ${stat.last_by}` : ""}
      {stat.acknowledged ? ` · ✓${stat.acknowledged}` : ""}
    </span>
  );
}
